import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-play\">\n  <g fill=\"currentColor\" fill-rule=\"evenodd\">\n    <path d=\"M0 40V0l37.07 20L0 40zM1.95 3.27v33.46L32.96 20l-31-16.73z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol